var render = function render(){var _vm=this,_c=_vm._self._c;return _c('circle',{staticClass:"cls-1",attrs:{"cx":_vm.data.cx,"cy":_vm.data.cy,"r":_vm.data.r}})
}
var staticRenderFns = []

export { render, staticRenderFns }